/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { all, fork } from 'redux-saga/effects';
import { signInSaga } from 'modules/sign-in/saga';
import { authSaga } from 'modules/common/auth/saga';
import { forgotPasswordSaga } from 'modules/forgot-password/saga';
import { resetPasswordSaga } from 'modules/reset-password/saga';
import { verifyTokenSaga } from 'modules/verify-callback/saga';
import { dashboardSaga } from 'modules/dashboard/saga';
import { rateCalendarSaga } from 'modules/rate-calendar/saga';
import { rateCalendarUploadSaga } from 'modules/rate-calendar-upload/saga';
import { userSaga } from 'modules/users/saga';
import { eventCategoryConfigurationSaga } from 'modules/event-configuration/saga';
import { signUpSaga } from 'modules/sign-up/saga';
import { workbookReportSaga } from 'modules/dashboard/components/tab-container/workbook-report/saga';
import { trendSaga } from 'modules/dashboard/components/tab-container/trend-tabs/saga';
import { trendTabularSaga } from 'modules/dashboard/components/tab-container/trend-tabular-tabs/saga';
import { alertSaga } from 'modules/dashboard/components/tab-container/alert-tab/saga';
import { searchSaga } from 'modules/dashboard/components/tab-container/search/saga';
import { regionalMapSaga } from 'modules/dashboard/components/tab-container/regional-map-tab/saga';
import { paceSaga } from 'modules/dashboard/components/tab-container/pace-tabs/saga';
import { customChatSaga } from 'modules/common/components/custom-chat-view/saga';

/**
 * Register all the saga functions into the root saga
 */
export default function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(signInSaga),
    fork(forgotPasswordSaga),
    fork(resetPasswordSaga),
    fork(verifyTokenSaga),
    fork(dashboardSaga),
    fork(rateCalendarSaga),
    fork(userSaga),
    fork(rateCalendarUploadSaga),
    fork(eventCategoryConfigurationSaga),
    fork(signUpSaga),
    fork(trendSaga),
    fork(workbookReportSaga),
    fork(trendTabularSaga),
    fork(alertSaga),
    fork(searchSaga),
    fork(regionalMapSaga),
    fork(paceSaga),
    fork(customChatSaga),
  ]);
}
